import React, { useEffect } from 'react'
import { ScrollingCarousel } from '@trendyol-js/react-carousel';
import { Link } from 'react-router-dom';
import { getPercent } from 'sdk/utils/assets';
import styles from 'modules/discovery/pages/Home/TopAssets/TopAssets.module.scss';
import Skeleton from 'components/shared/Skeleton';
import clsx from 'clsx';
import useGetIndexByQuery from 'sdk/hooks/search/useGetIndexByQuery';
import SearchBlock from './SerachBlock';

type Props = {
  search: string,
  selectedCategory?: string,
  setNotFound?: (state: boolean) => void,
}

export default function Assets({ search, selectedCategory, setNotFound }: Props) {
  const {
    mutate: getIndex,
    isLoading: loading,
    data,
  } = useGetIndexByQuery()

  useEffect(() => {
    if (search !== undefined) {
      getIndex({
        query: search, index: 'assets', category: selectedCategory === 'All' ? '' : selectedCategory,
      })
    }
  }, [search, selectedCategory])

  useEffect(() => {
    if (setNotFound) {
      if (!loading && !data?.length) {
        setNotFound(true)
      } else {
        setNotFound(false)
      }
    }
  }, [loading, data?.length])

  // @ts-ignore
  if (loading && !data?.length) {
    return (
      <SearchBlock title="Assets">
        <ScrollingCarousel className={styles.picks}>
          {Array.from(Array(9).keys()).map((item) => (
            <Skeleton className={clsx(styles.picksItem, styles.picksItemSkeleton)} key={item} />
          ))}
        </ScrollingCarousel>
      </SearchBlock>
    )
  }

  if (!data?.length) {
    return null
  }

  return (
    <SearchBlock title="Assets" className={loading ? 'blockLoading' : ''}>
      <ScrollingCarousel className={styles.picks}>
        {data?.map((asset: any) => (
          <Link
            to={`/asset/${asset?.category_id}/${asset?.ticker}`}
            key={asset?.objectID}
            className={styles.picksItem}
            onMouseDown={(e) => e.preventDefault()}
          >
            <img src={asset?.icon} alt={asset?.ticker} />
            <span className={styles.picksItemChanges}>
              {getPercent(asset?.details)}
              %
            </span>
          </Link>
        ))}
      </ScrollingCarousel>
    </SearchBlock>
  )
}
